import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import ValidationError from "../../ZodError";
import { LatestMetadata, PortfolioPlan, PublishMetadata, } from "../types";
export const PortfolioPlanResponse = PortfolioPlan.extend({
    activeClientCount: z.number().optional(),
    accountsAppliedCount: z.number().optional(),
    dependentPlanCount: z.number().optional(),
    provider: z.string().optional(),
    numberOfSecurities: z.number().optional(),
});
export const portfolioPlanByIdURL = (portfolioPlanId) => environment() === "PROD"
    ? `https://middleware.prod.farther.com/investment/portfolio-plans/${portfolioPlanId}`
    : `https://middleware.uat.farther.com/investment/portfolio-plans/${portfolioPlanId}`;
// accept query parameters for the request
export const PortfolioPlanByIdResponse = z.object({
    data: z.object({
        plan: PortfolioPlanResponse,
        publishMetadata: PublishMetadata.optional(),
        latestMetadata: LatestMetadata.optional(),
    }),
});
export const stringifyQueryParams = (params) => {
    const qs = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (value === undefined) {
            return;
        }
        if (Array.isArray(value)) {
            value.forEach((v) => qs.append(key, v));
            return;
        }
        qs.append(key, value);
    });
    return qs.toString();
};
export const getPortfolioPlanById = async (portfolioPlanId, params, config) => {
    const qs = stringifyQueryParams(params);
    const { data } = await axios.get(`${portfolioPlanByIdURL(portfolioPlanId)}?${qs}`, {
        headers: {
            version: "20240916",
            Authorization: `Bearer ${config.jwt}`,
            ...("clientId" in config && { Client: config.clientId }),
            ...("advisorId" in config && { Advisor: config.advisorId }),
            accept: "application/json",
        },
    });
    const decoded = PortfolioPlanByIdResponse.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = `[getPortfolioPlanById.ts] received unexpected data`;
        errorLog(errorMessage, decoded.error.message);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
};
//# sourceMappingURL=getPortfolioPlanById.js.map